import Swiper from '../libs/swiper.4.5.0.min'

$(function () {
  var $slider = $('.b-latest-videos .swiper-container'),
    nSliders = $slider.find('.swiper-slide').length,
    isPortraitTablet = window.screen.width > 450 && window.screen.width <= 768

  // In Tablet Portrait each slider has 4 items (2 rows wit 2 items per row)
  if (isPortraitTablet) {
    setItemsPerSlide($slider, 4)
  }

  if (nSliders > 1) {
    new Swiper($slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      },
      pagination: {
        el: '.swiper-pagination',
      },
      preloadImages: false,
      lazyLoading: true,
      lazyLoadingInPrevNext: true,
      paginationClickable: true,
    })
  }

  function setItemsPerSlide($slider, numItems) {
    $slider.find('.swiper-wrapper').prepend($slider.find('.video-row'))
    $slider.find('.swiper-slide').remove()

    var productdivs = $slider.find('.video-row')
    for (var i = 0; i < productdivs.length; i += Math.ceil(numItems / 2)) {
      productdivs.slice(i, i + 2).wrapAll("<div class='swiper-slide'></div>")
    }
  }
})
